import React, { useContext } from 'react';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import ProjectCostsHiringPro from '/src/Components/ProjectCostsHiringPro/ProjectCostsHiringPro';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';
import { WindowSizeContext } from '/src/App';

import './style.css';

const EngagingProsLaborCard = ({
    group,
    handleGroupClick,
    isSelected = false,
    showLaborDetails = true,
    showResources = false,
    canBeClicked = true
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const resources = group.labor_type_resources;

    const whoDoesWorkText = group.who_does_work;

    const whoDoesWorkTextFormatted = whoDoesWorkText === 'None' ? 'Handyman' : whoDoesWorkText;

    const whoDoesWorkDisclaimer = "We estimate the cost at 0 because this project doesn't generally require a professional."

    return (
        <div
            key={group.who_does_work}
            className={`engaging-pros-group ${isSelected ? 'selected' : ''} ${deviceType}`}
            onClick={isSelected ? null : () => handleGroupClick(group)}
        >
            {showLaborDetails && (
                <>
                    <div className="engaging-pros-group-header">
                        <div className="engaging-pros-icon-container">
                            <img
                                src={CreateCloudfrontUrl(group.who_does_work_icon)}
                                alt={`${group.who_does_work} icon`}
                                className="engaging-pros-icon"
                            />
                        </div>
                        <h2 className="engaging-pros-group-title">{whoDoesWorkTextFormatted}</h2>
                    </div>
                    <CurlyBraceDivider />
                </>
            )}
            <div className="engaging-pros-projects-list">
                {group.projects_list.map((project, projectIndex) => (
                    <div key={projectIndex} className="engaging-pros-project-container">
                        <ProjectsListCard
                            key={projectIndex}
                            project={project}
                            handleProjectClick={null}
                            isSelected={null}
                            showAllDetails={false}
                            simulatorView={false}
                        />
                        <ProjectCostsHiringPro project={project} />
                        {project.project_cost_labor === 0 && (
                            <div className="engaging-pros-project-cost-disclaimer text-align-center">
                                <span>{whoDoesWorkDisclaimer}</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {showResources && (
                <div className="engaging-pros-resources-container">
                    {resources.map((resource, resourceIndex) => (
                        <ResourceCard key={resourceIndex} resource={resource} showTags={false} />
                    ))}
                </div>
            )}
        </div>
    )
}

export default EngagingProsLaborCard;